import type { ReactNode } from 'react'
import { Notice } from '../design/index.js'
import { ApiError } from '../app/api.js'

export const Loading = ({ what = 'Loading…' }: { what?: string }) => <p className="loading">{what}</p>

export const messageFor = (error: unknown): string => {
  if (error instanceof ApiError) return error.message
  if (error instanceof Error) return error.message
  return 'Something went wrong. Try again.'
}

export const ErrorBlock = ({ error }: { error: unknown }) => (
  <Notice kind="bad">{messageFor(error)}</Notice>
)

export type Tone = 'info' | 'warn' | 'bad' | 'good'

const KIND = { info: 'info', warn: 'warn', bad: 'bad', good: 'ok' } as const

/** The advisory tones the server sends, mapped onto the design system's kinds. */
export const NoticeBlock = ({ tone, children }: { tone: Tone; children: ReactNode }) => (
  <Notice kind={KIND[tone]}>{children}</Notice>
)
